export default __webpack_public_path__ + "static/ten-growing-trends-part-2-3c8b78d79c241e498b2d8d3c2ee620a3.jpg";